export const USER_AUTHORIZATION_TOKEN_KEY = 'USER_AUTHORIZATION_TOKEN';
export const USER_SESSION_STATE_KEY = 'USER_SESSION_STATE';
export const USER_SESSION_CACHED = 'USER_SESSION_CACHED';
export const USER_SESSION_REFRESHED = 'USER_SESSION_REFRESHED';
export const LOGIN_VISIT_REDIRECT_PATH = 'LOGIN_VISIT_REDIRECT_PATH';
export const USER_SESSION_ID = 'USER_SESSION_ID';
export const USER_SESSION_COOKIE_EXPIRY_TIME =
  'USER_SESSION_COOKIE_EXPIRY_TIME';
/**
 * Domains for which we want to enable bulk operations via Catalyst V2 APIs
 */
export const CATALYST_V2_ALLOWED_DOMAINS = ['MC', 'INTERVENTIONS', 'WA', 'DT'];
export const BULK_EMAILS_ALLOWED_DOMAINS = ['MC'];

/**
 * Domains that list case attachments via the Catalyst GetAssetsV2 API
 * (`/api/v2/get-assets`) instead of GetCaseAdditionalDetails (`/api/v1/...`).
 * The delete action still uses the same DeleteAttachmentV2 API for every
 * domain; only the listing/read path differs. A domain absent from this set
 * falls back to the V1 GetCaseAdditionalDetails listing.
 */
export const ATTACHMENT_LISTING_V2_DOMAINS = [
  'ATP', // Payroll
  'NJS',
  'DEPARTURES',
  'INTERVENTIONS',
  'WA',
  'DT',
  'MC',
  'BGC',
  'IMH'
];

/**
 * True when the given domain should list attachments via GetAssetsV2 rather
 * than GetCaseAdditionalDetails.
 */
export const usesGetAssetsV2ForAttachmentListing = (
  domainId: string
): boolean => ATTACHMENT_LISTING_V2_DOMAINS.includes(domainId);
